import {ApiClient} from '@hconnect/apiclient'
import {useUpmPlantContext} from '@hconnect/upm'
import {useQuery} from '@tanstack/react-query'

import {PlannerFeature} from '../enums'

/**
 * @deprecated Remove after planner features are exported to config cat
 */
export const usePlannerFeature = (feature: PlannerFeature) => {
  const {data: plantConfig} = usePlantConfigQuery()
  const availableFeatures = plantConfig?.available_features || []

  return availableFeatures.includes(feature)
}

interface PlantConfigData {
  available_features: PlannerFeature[]
}

export const PlantConfigQueryKey = 'plantConfig'

const usePlantConfigQuery = () => {
  // Use UpmPlantContext to get plantCode - works in both HCEM and Suite
  const {plantId: plantCode} = useUpmPlantContext()

  return useQuery<PlantConfigData>({
    queryKey: [PlantConfigQueryKey, plantCode],
    queryFn: async ({signal}) => {
      const response = await ApiClient.axiosInstance.get<PlantConfigData>(
        `/hcem/ui/v2/config/${plantCode}`,
        {signal}
      )
      return response.data
    },
    enabled: Boolean(plantCode)
  })
}
